import themeUtils from '../themeUtils';

export default class DynamicBlog {
  constructor(section) {
    this.container = 'data-blog-container';
    this.slide = '.home-blog-post';
    this.el = section.el;
    this.$el = $(this.el);
    this.$window = $(window);
    this.$container = this.$el.find(`[${this.container}]`);
    this.flickity = null;
    this._flickity = this._flickity.bind(this);
    this._bindEvents();
    this._flickity();
  }


  _bindEvents() {
    return this.$window.on('resize.home-blog-posts', themeUtils.debounce(this._flickity, 100));
  }

  onSectionUnload() {
    this.$window.off('resize.home-blog-posts');
    this._destroyFlickity();
  }

  _flickity() {
    if (!this.$container.length) { return; }

    // If larger than 'small', destroy Flickity and exit
    if (!themeUtils.isSmall()) {
      return this._destroyFlickity();
    }

    // If Flickity is initialised, exit
    if (this.flickity) {
      return;
    }

    this.flickity = new Flickity(this.$container[0], {
      cellAlign: 'left',
      cellSelector: this.slide,
      contain: false,
      prevNextButtons: false,
      pageDots: false,
      setGallerySize: false,
    });


    this._flickityEvents();
  }

  _destroyFlickity() {
    if (this.flickity) {
      this.flickity.destroy();
      this.flickity = null;

      this.$window.off('resize.home-blog-posts-flickity');
      this.$container.off('home-blog-posts-height');
      this.$container.off('rimg:load');
    }
  }

  _flickityEvents() {
    // Check for tallest slide at start of transition
    this.flickity.on('cellSelect', () => this.$container.trigger('home-blog-posts-height'));

    // Check for tallest slide at end of transition
    this.flickity.on('settle', () => this.$container.trigger('home-blog-posts-height'));

    this.$container.on('home-blog-posts-height', () => themeUtils.flickityResize(this.flickity));
    this.$container.on('rimg:load', () => themeUtils.flickityResize(this.flickity));

    // Sets the Slider to the height of the first slide
    this.$container.trigger('home-blog-posts-height');

    this.$window.on('resize.home-blog-posts-flickity',
      themeUtils.debounce(() => this.$container.trigger('home-blog-posts-height'), 10)
    );
  }
}
